<h4 class="mines-bs__title typography-title flex items-center gap-4">
  <app-game-icon game="Mines"></app-game-icon>
  Place Your Bet
</h4>
@let isGameActive = minesService.currentGame().status === 'active';
<div class="mines-bs__inputs">
  <div class="mines-bs--bet-input">
    <app-old-slider
      [(value)]="minesService.amount"
      [disabled]="isGameActive"
      [uiSettings]="{
        thumbSize: '12px',
        trackHeight: '6px',
      }"
    ></app-old-slider>
    <app-input-options
      [(value)]="minesService.amount"
      [icon]="sessionService.balanceIconSrc()"
      [options]="betInputOptions"
      [disabledInput]="isGameActive"
      [disabledOptions]="isGameActive"
      [placeholder]="sessionService.balanceType() + ' value'"
      [settings]="{
      optionType: 'square',
      maskSettings: {
        mask: 'percent.2',
      },
    }"
    />
  </div>
  <div class="mines-bs--bet-buttons">
    @for (item of betButtons; track $index) {
    <button
      class="button button--style-primary button--style-primary-bordered padding-x-8 rounded-4 h-32"
      (click)="item.fn()"
      [disabled]="isGameActive"
    >
      <app-balance-icon
        [balance]="session.balanceType()"
        color="var(--yellow)"
      ></app-balance-icon>
      {{ item.label }}
    </button>
    }
  </div>
  <app-input-options
    icon="assets/icons/games/mines.svg"
    [options]="minesInputOptions"
    placeholder="Mines"
    [(value)]="minesService.mines"
    [settings]="{
      optionType: 'square',
    }"
    [disabledInput]="true"
    [disabledOptions]="isGameActive"
  />
  <button
    class="mines-bs--button"
    [disabled]="isGameActive && minesService.clicked().length === 0"
    (click)="isGameActive ? minesService.checkout() : handleStartGame()"
  >
    {{
      isGameActive
        ? "CASH OUT"
        : minesService.currentGame().status === "finished"
        ? "PLAY AGAIN"
        : "PLACE BET"
    }}
  </button>
  @if (minesService.currentGame().status || minesService.repeat()) {
  <div @fadeInAnimation class="mines-bs--cg">
    <div
      class="mines-bs--cg__processing flex items-center justify-center gap-4"
    >
      <span class="dots-animation">
        {{
          minesService.currentGame().status !== "finished"
            ? "Game In Progress"
            : "Results"
        }}
      </span>
    </div>
    <div class="mines-bs--cg__progress">
      <div class="mines-bs--cg__progress-item multiplier">
        <span>
          {{ minesService.multiplier() | currency : "" : "" : "1.2-2" }}x
        </span>
      </div>
      <div class="mines-bs--cg__progress-item score">
        <app-balance-icon
          [balance]="minesService.currentGame().balancetype"
          color="var(--yellow)"
        ></app-balance-icon>
        {{
          minesService.multiplier() *
            (minesService.currentGame().value ?? minesService.amount())
            | currency : "" : "" : "1.2-2"
        }}
      </div>
    </div>
  </div>
  }
</div>

<div class="mines-bs--bottom">
  <app-fairness-button [href]="'/provably-fair/mines/'"></app-fairness-button>
  <div class="mines-bs--seed">
    <span class="mines-bs--seed__title">Client Seed:</span>
    <span
      class="mines-bs--seed__value"
      (click)="
        clipboardService.copy(
          session.clientSeed()?.seed ?? '',
          'Client Seed copied!'
        )
      "
    >
      {{ session.clientSeed()?.seed }}
    </span>
  </div>
</div>
